import axios from "./axios";

export default class AgreementService {
  static createAgreement() {
    return axios.post(window.entityCabinetSettings.openApi.url + '/api/agreement/credit-register/create');
  }

  static signAgreement(agreement_id, otp) {
    return axios.post(window.entityCabinetSettings.openApi.url + '/api/agreement/credit-register/sign', { agreement_id, otp });
  }

  static revokePersonalDataAgreement() {
    return axios.post(window.entityCabinetSettings.openApi.url + '/api/agreement/personal-data/revoke');
  }

  static createPersonalDataAgreement() {
    return axios.post(window.entityCabinetSettings.openApi.url + '/api/agreement/personal-data/create');
  }

  static downloadPersonalDataAgreement(agreementId) {
    return axios.get(window.entityCabinetSettings.openApi.url + `/api/agreement/personal-data/download/${agreementId}`, {
      responseType: 'blob'
    });
  }

  static signPersonalDataAgreement(agreement_id, otp) {
    return axios.post(window.entityCabinetSettings.openApi.url + '/api/agreement/personal-data/sign', { agreement_id, otp });
  }
}
